
// import React, { useState, useEffect } from 'react';
// import { Chart, registerables } from 'chart.js';
// import { useSelector } from 'react-redux';
// import api from '../../Services/api';
// import '../../Styles/Dashboard.css';

// Chart.register(...registerables);

// // Skeleton Components
// const SkeletonStatsCard = () => (
//   <div className="stats-card skeleton">
//     <div className="stats-content">
//       <div className="stats-info">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-value"></div>
//         <div className="skeleton-subtitle"></div>
//       </div>
//       <div className="stats-icon skeleton-icon"></div>
//     </div>
//   </div>
// );

// const SkeletonChartCard = () => (
//   <div className="chart-card skeleton">
//     <div className="chart-header">
//       <div className="skeleton-chart-title"></div>
//     </div>
//     <div className="chart-wrapper">
//       <div className="skeleton-chart"></div>
//     </div>
//   </div>
// );

// const SkeletonUserListCard = () => (
//   <div className="list-card skeleton">
//     <div className="list-header">
//       <div className="skeleton-list-title"></div>
//       <div className="skeleton-button"></div>
//     </div>
//     <div className="list-content">
//       <div className="skeleton-table">
//         {[1, 2, 3, 4, 5].map((i) => (
//           <div key={i} className="skeleton-row">
//             {[1, 2, 3, 4].map((j) => (
//               <div key={j} className="skeleton-cell"></div>
//             ))}
//           </div>
//         ))}
//       </div>
//     </div>
//     <div className="quick-stats">
//       <div className="quick-stat">
//         <div className="skeleton-stat"></div>
//       </div>
//       <div className="quick-stat">
//         <div className="skeleton-stat"></div>
//       </div>
//     </div>
//   </div>
// );

// const SkeletonRecentBookings = () => (
//   <div className="recent-bookings skeleton">
//     <div className="recent-header">
//       <div className="skeleton-recent-title"></div>
//       <div className="skeleton-button"></div>
//     </div>
//     <div className="bookings-table">
//       <div className="skeleton-table">
//         {[1, 2, 3, 4, 5].map((i) => (
//           <div key={i} className="skeleton-row">
//             {[1, 2, 3, 4, 5, 6].map((j) => (
//               <div key={j} className="skeleton-cell"></div>
//             ))}
//           </div>
//         ))}
//       </div>
//     </div>
//   </div>
// );

// const Home = () => {
//   const { token } = useSelector((state) => state.user);
  
//   const [dashboardData, setDashboardData] = useState({
//     revenue: 0,
//     totalTickets: 0,
//     bookedTickets: 0,
//     returnedTickets: 0,
//     totalUsers: 0,
//     totalBusOwners: 0,
//     totalDrivers: 0,
//     recentBookings: [],
//     weeklyTickets: [],
//     todayTickets: [],
//     usersList: [],
//     busOwnersList: [],
//     driversList: [],
//     conductorsList: [],
//     allBookings: [],
//     allBusOwners: [],
//     allDrivers: [],
//     allConductors: [],
//     allUsers: [],
//     incomeData: [],
//     expenseData: [],
//     bookingData: [],
//     cancelData: [],
//     paymentMethods: {
//       cash: 0,
//       email: 0,
//       mobile: 0,
//       paypal: 0
//     }
//   });

//   const [selectedPeriod, setSelectedPeriod] = useState('Today');
//   const [loading, setLoading] = useState(true);
//   const [modal, setModal] = useState({
//     isOpen: false,
//     type: '',
//     title: '',
//     data: [],
//     columns: []
//   });

//   const incomeExpenseChartRef = React.useRef(null);
//   const ticketBookingChartRef = React.useRef(null);
//   const paymentMethodsChartRef = React.useRef(null);

//   useEffect(() => {
//     fetchAllData();
//   }, [selectedPeriod]);

//   useEffect(() => {
//     if (dashboardData.incomeData && dashboardData.bookingData && !loading) {
//       createCharts();
//     }

//     return () => {
//       if (incomeExpenseChartRef.current) incomeExpenseChartRef.current.destroy();
//       if (ticketBookingChartRef.current) ticketBookingChartRef.current.destroy();
//       if (paymentMethodsChartRef.current) paymentMethodsChartRef.current.destroy();
//     };
//   }, [dashboardData, loading]);

//   const fetchAllData = async () => {
//     try {
//       setLoading(true);
      
//       const config = {
//         headers: {
//           'Authorization': `Bearer ${token}`
//         }
//       };

//       const [
//         dashboardStats,
//         usersResponse,
//         busOwnersResponse,
//         driversResponse,
//         conductorsResponse,
//         bookingsResponse
//       ] = await Promise.all([
//         api.get('/dashboard', config),
//         api.get('/users', config),
//         api.get('/bus-owners', config),
//         api.get('/drivers', config),
//         api.get('/conductors', config),
//         api.get('/bookings', config)
//       ]);

//       const stats = dashboardStats.data.stats || {};
 
//       const users = usersResponse.data.users || [];

//       const busOwners = busOwnersResponse.data.busOwners || [];
      
//       const drivers = driversResponse.data.drivers || [];

//       const conductors = conductorsResponse.data.conductors || [];

//       const bookings = bookingsResponse.data.bookings || [];

//       console.log("bookings : ",bookings)

//       const chartData = generateChartData(selectedPeriod);

//       const filteredBookings = filterBookingsByPeriod(bookings, selectedPeriod);
      
//       setDashboardData({
//         revenue: stats.totalRevenue || stats.paymentCollectionRevenue || 0,
//         totalTickets: stats.totalBookings || stats.ticketOrdered || 0,
//         bookedTickets: stats.bookedTickets || 0,
//         returnedTickets: stats.refundedTickets || 0,
//         totalUsers: stats.totalUsers || users.length,
//         totalBusOwners: stats.totalOwners || busOwners.length,
//         totalDrivers: drivers.length,
//         recentBookings: filteredBookings.slice(0, 5),
//         usersList: users.slice(0, 5),
//         busOwnersList: busOwners.slice(0, 5),
//         driversList: drivers.slice(0, 5),
//         conductorsList: conductors.slice(0, 5),
//         allBookings: bookings,
//         allUsers: users,
//         allBusOwners: busOwners,
//         allDrivers: drivers,
//         allConductors: conductors,
//         ...chartData
//       });

//       setLoading(false);
//     } catch (error) {
//       console.error('Error fetching dashboard data:', error);
//       setLoading(false);
//     }
//   };

//   const generateChartData = (period) => {
//     const multipliers = {
//       'Today': 1,
//       'This Week': 7,
//       'This Month': 30,
//       'This Year': 365
//     };
    
//     const mult = multipliers[period] || 1;
    
//     return {
//       weeklyTickets: Array(7).fill(0).map(() => Math.floor(Math.random() * 50 * mult)),
//       todayTickets: Array(12).fill(0).map(() => Math.floor(Math.random() * 30 * mult)),
//       incomeData: Array(12).fill(0).map(() => Math.floor(Math.random() * 10000 * mult)),
//       expenseData: Array(12).fill(0).map(() => Math.floor(Math.random() * 5000 * mult)),
//       bookingData: Array(12).fill(0).map(() => Math.floor(Math.random() * 3000 * mult)),
//       cancelData: Array(12).fill(0).map(() => Math.floor(Math.random() * 1000 * mult)),
//       paymentMethods: {
//         cash: Math.floor(Math.random() * 50),
//         email: Math.floor(Math.random() * 30),
//         mobile: Math.floor(Math.random() * 20),
//         paypal: Math.floor(Math.random() * 15)
//       }
//     };
//   };

//   const filterBookingsByPeriod = (bookings, period) => {
//     const today = new Date();
    
//     return bookings.filter(booking => {
//       const bookingDate = new Date(booking.bookedOn || booking.createdAt);
      
//       switch (period) {
//         case 'Today':
//           return bookingDate.toDateString() === today.toDateString();
//         case 'This Week':
//           const startOfWeek = new Date(today);
//           startOfWeek.setDate(today.getDate() - today.getDay());
//           return bookingDate >= startOfWeek;
//         case 'This Month':
//           return bookingDate.getMonth() === today.getMonth() && 
//                  bookingDate.getFullYear() === today.getFullYear();
//         case 'This Year':
//           return bookingDate.getFullYear() === today.getFullYear();
//         default:
//           return true;
//       }
//     });
//   };

//   const createCharts = () => {
//     const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

//     const incomeExpenseCtx = document.getElementById('incomeExpenseChart');
//     if (incomeExpenseCtx) {
//       if (incomeExpenseChartRef.current) incomeExpenseChartRef.current.destroy();
      
//       incomeExpenseChartRef.current = new Chart(incomeExpenseCtx, {
//         type: 'bar',
//         data: {
//           labels: months,
//           datasets: [
//             {
//               label: 'Income',
//               data: dashboardData.incomeData,
//               backgroundColor: '#4CAF50',
//               borderColor: '#388E3C',
//               borderWidth: 1,
//               borderRadius: 4,
//             },
//             {
//               label: 'Expenses',
//               data: dashboardData.expenseData,
//               backgroundColor: '#F44336',
//               borderColor: '#D32F2F',
//               borderWidth: 1,
//               borderRadius: 4,
//             }
//           ]
//         },
//         options: {
//           responsive: true,
//           maintainAspectRatio: false,
//           plugins: {
//             legend: {
//               position: 'top',
//               labels: { usePointStyle: true, padding: 15, font: { size: 11 } }
//             },
//             title: {
//               display: true,
//               text: 'Income & Expense',
//               font: { size: 14, weight: 'bold' },
//               padding: 10
//             }
//           },
//           scales: {
//             x: { grid: { display: false }, ticks: { font: { size: 10 } } },
//             y: {
//               beginAtZero: true,
//               ticks: {
//                 font: { size: 10 },
//                 callback: function(value) {
//                   return value >= 1000 ? value/1000 + 'k' : value;
//                 }
//               },
//               grid: { color: '#f0f0f0' }
//             }
//           }
//         }
//       });
//     }

//     const ticketBookingCtx = document.getElementById('ticketBookingChart');
//     if (ticketBookingCtx) {
//       if (ticketBookingChartRef.current) ticketBookingChartRef.current.destroy();
      
//       ticketBookingChartRef.current = new Chart(ticketBookingCtx, {
//         type: 'bar',
//         data: {
//           labels: months,
//           datasets: [
//             {
//               label: 'Book',
//               data: dashboardData.bookingData,
//               backgroundColor: '#2196F3',
//               borderColor: '#1976D2',
//               borderWidth: 1,
//               borderRadius: 4,
//             },
//             {
//               label: 'Cancel',
//               data: dashboardData.cancelData,
//               backgroundColor: '#FF9800',
//               borderColor: '#F57C00',
//               borderWidth: 1,
//               borderRadius: 4,
//             }
//           ]
//         },
//         options: {
//           responsive: true,
//           maintainAspectRatio: false,
//           plugins: {
//             legend: {
//               position: 'top',
//               labels: { usePointStyle: true, padding: 15, font: { size: 11 } }
//             },
//             title: {
//               display: true,
//               text: 'Ticket Booking & Canceled',
//               font: { size: 14, weight: 'bold' },
//               padding: 10
//             }
//           },
//           scales: {
//             x: { grid: { display: false }, ticks: { font: { size: 10 } } },
//             y: {
//               beginAtZero: true,
//               ticks: {
//                 font: { size: 10 },
//                 callback: function(value) {
//                   return value >= 1000 ? value/1000 + 'k' : value;
//                 }
//               },
//               grid: { color: '#f0f0f0' }
//             }
//           }
//         }
//       });
//     }

//     const paymentMethodsCtx = document.getElementById('paymentMethodsChart');
//     if (paymentMethodsCtx) {
//       if (paymentMethodsChartRef.current) paymentMethodsChartRef.current.destroy();
      
//       paymentMethodsChartRef.current = new Chart(paymentMethodsCtx, {
//         type: 'pie',
//         data: {
//           labels: ['Cash', 'Email', 'Mobile', 'PayPal'],
//           datasets: [{
//             data: [
//               dashboardData.paymentMethods.cash,
//               dashboardData.paymentMethods.email,
//               dashboardData.paymentMethods.mobile,
//               dashboardData.paymentMethods.paypal
//             ],
//             backgroundColor: ['#4CAF50', '#2196F3', '#FF9800', '#9C27B0'],
//             borderColor: '#fff',
//             borderWidth: 2,
//             hoverOffset: 8
//           }]
//         },
//         options: {
//           responsive: true,
//           maintainAspectRatio: false,
//           plugins: {
//             legend: {
//               position: 'bottom',
//               labels: { usePointStyle: true, padding: 15, font: { size: 11 } }
//             },
//             title: {
//               display: true,
//               text: 'Payment Methods',
//               font: { size: 14, weight: 'bold' },
//               padding: 10
//             }
//           }
//         }
//       });
//     }
//   };

//   const StatsCard = ({ title, value, subtitle, icon, color = "#2f92c4" }) => (
//     <div className="stats-card" style={{ borderLeftColor: color }}>
//       <div className="stats-content">
//         <div className="stats-info">
//           <h3>{title}</h3>
//           <h2>{value.toLocaleString()}</h2>
//           <p>{subtitle}</p>
//         </div>
//         <div className="stats-icon">{icon}</div>
//       </div>
//     </div>
//   );

//   const UserListCard = ({ title, data, allData, columns }) => (
//     <div className="list-card">
//       <div className="list-header">
//         <h3>{title}</h3>
//         <button 
//           className="view-all-btn" 
//           onClick={() => openModal(title, allData, columns)}
//         >
//           View All
//         </button>
//       </div>
//       <div className="list-content">
//         <table>
//           <thead>
//             <tr>
//               {columns.map((col, index) => (
//                 <th key={index}>{col}</th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {data.slice(0, 5).map((item, index) => (
//               <tr key={item._id || item.id || index}>
//                 {columns.map((col, cellIndex) => {
//                   let value = '';

//                   switch (col) {
//                     case 'Name':
//                       value = item.name || 'N/A';
//                       break;
//                     case 'Email':
//                       value = item.email || 'N/A';
//                       break;
//                     case 'Phone':
//                       value = item.phone || item.mobileNumber || 'N/A';
//                       break;
//                     case 'Company':
//                       value = item.company || 'N/A';
//                       break;
//                     case 'Buses':
//                       value = item.busCount || item.buses || 0;
//                       break;
//                     case 'Bus':
//                       value = item.assignedBus?.busNumber || item.bus || 'N/A';
//                       break;
//                     case 'Experience':
//                       value = item.experience || 'N/A';
//                       break;
//                     case 'Joined':
//                       value = item.createdAt ? new Date(item.createdAt).toLocaleDateString() : 'N/A';
//                       break;
//                     case 'License':
//                       value = item.licenseNumber || 'N/A';
//                       break;
//                     default:
//                       value = item[col.toLowerCase()] || 'N/A';
//                   }
                  
//                   return <td key={cellIndex}>{value}</td>;
//                 })}
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//       <div className="quick-stats">
//         <div className="quick-stat">
//           <h4>Total</h4>
//           <p>{allData.length}</p>
//         </div>
//         <div className="quick-stat">
//           <h4>Active</h4>
//           <p>{allData.filter(item => item.isActive !== false).length}</p>
//         </div>
//       </div>
//     </div>
//   );

//   const openModal = (title, data, columns) => {
//     setModal({
//       isOpen: true,
//       type: title.toLowerCase().replace(' ', '-'),
//       title: `All ${title} - ${selectedPeriod}`,
//       data: data,
//       columns: [...columns, 'Status']
//     });
//   };

//   const closeModal = () => {
//     setModal({
//       isOpen: false,
//       type: '',
//       title: '',
//       data: [],
//       columns: []
//     });
//   };

//   const Modal = () => {
//     if (!modal.isOpen) return null;

//     return (
//       <div className="modal-overlay" onClick={closeModal}>
//         <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//           <div className="modal-header">
//             <h3>{modal.title}</h3>
//             <button className="modal-close-btn" onClick={closeModal}>×</button>
//           </div>
//           <div className="modal-body">
//             <div className="modal-table-container">
//               <table className="modal-table">
//                 <thead>
//                   <tr>
//                     {modal.columns.map((col, index) => (
//                       <th key={index}>{col}</th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {modal.data.map((item, index) => (
//                     <tr key={item._id || item.id || index}>
//                       {modal.columns.map((col, colIndex) => {
//                         let value = '';
                        
//                         if (col === 'Status') {
//                           value = item.isActive === false ? 'Inactive' : item.status || 'Active';
//                           return (
//                             <td key={colIndex}>
//                               <span className={`status-badge ${value.toLowerCase()}`}>
//                                 {value}
//                               </span>
//                             </td>
//                           );
//                         }

//                         switch (col) {
//                           case 'Name':
//                             value = item.name || 'N/A';
//                             break;
//                           case 'Email':
//                             value = item.email || 'N/A';
//                             break;
//                           case 'Phone':
//                             value = item.phone || item.mobileNumber || 'N/A';
//                             break;
//                           case 'Buses':
//                             value = item.busCount || item.buses || 0;
//                             break;
//                           case 'Bus':
//                             value = item.assignedBus?.busNumber || item.bus || 'N/A';
//                             break;
//                           case 'Experience':
//                             value = item.experience || 'N/A';
//                             break;
//                           case 'Joined':
//                             value = item.createdAt ? new Date(item.createdAt).toLocaleDateString() : 'N/A';
//                             break;
//                           case 'License':
//                             value = item.licenseNumber || 'N/A';
//                             break;
//                           case 'PNR':
//                             value = item.pnr || 'N/A';
//                             break;
//                           case 'Passenger':
//                             value = item.user?.name || 'N/A';
//                             break;
//                           case 'Route':
//                             value = item.route ? `${item.route.from} to ${item.route.to}` : 'N/A';
//                             break;
//                           case 'Amount':
//                             value = `₹${item.amount || 0}`;
//                             break;
//                           case 'Date':
//                             value = item.bookedOn ? new Date(item.bookedOn).toLocaleDateString() : 'N/A';
//                             break;
//                           default:
//                             value = item[col.toLowerCase()] || 'N/A';
//                         }
                        
//                         return <td key={colIndex}>{value}</td>;
//                       })}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//             {modal.data.length === 0 && (
//               <div className="no-data">
//                 <p>No data available</p>
//               </div>
//             )}
//           </div>
//           <div className="modal-footer">
//             <p>Total Records: {modal.data.length}</p>
//             <button className="modal-close-btn secondary" onClick={closeModal}>
//               Close
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   if (loading) {
//     return (
//       <div className="dashboard">
//         <div className="dashboard-header">
//           <div className="skeleton-header"></div>
//           <div className="skeleton-filter"></div>
//         </div>

//         <div className="stats-grid">
//           {[1, 2, 3, 4, 5, 6, 7].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <div className="charts-container">
//           <div className="chart-row">
//             <SkeletonChartCard />
//             <SkeletonChartCard />
//             <SkeletonChartCard />
//           </div>
//         </div>

//         <div className="content-container">
//           <div className="charts-section">
//             <SkeletonChartCard />
//             <SkeletonChartCard />
//           </div>

//           <div className="lists-section">
//             <SkeletonUserListCard />
//             <SkeletonUserListCard />
//             <SkeletonUserListCard />
//             <SkeletonUserListCard />
//           </div>
//         </div>

//         <SkeletonRecentBookings />
//       </div>
//     );
//   }

//   return (
//     <div className="dashboard">
//       <div className="dashboard-header">
//         <h1>Dashboard - {selectedPeriod} View</h1>
//         <div className="date-filter">
//           <select 
//             value={selectedPeriod} 
//             onChange={(e) => setSelectedPeriod(e.target.value)}
//           >
//             <option value="Today">Today</option>
//             <option value="This Week">This Week</option>
//             <option value="This Month">This Month</option>
//             <option value="This Year">This Year</option>
//           </select>
//         </div>
//       </div>

//       <div className="stats-grid">
//         <StatsCard
//           title="TOTAL REVENUE"
//           value={dashboardData.revenue}
//           subtitle={`${selectedPeriod} revenue`}
//           icon="💰"
//         />
//         <StatsCard
//           title="TICKET ORDERED"
//           value={dashboardData.totalTickets}
//           subtitle={`${selectedPeriod} tickets`}
//           icon="🎫"
//         />
//         <StatsCard
//           title="BOOKED TICKETS"
//           value={dashboardData.bookedTickets}
//           subtitle={`${selectedPeriod} booked`}
//           icon="✅"
//         />
//         <StatsCard
//           title="RETURNED TICKETS"
//           value={dashboardData.returnedTickets}
//           subtitle={`${selectedPeriod} returns`}
//           icon="↩️"
//         />
//         <StatsCard
//           title="NEW USERS"
//           value={dashboardData.totalUsers}
//           subtitle={`${selectedPeriod} new users`}
//           icon="👥"
//         />
//         <StatsCard
//           title="BUS OWNERS"
//           value={dashboardData.totalBusOwners}
//           subtitle="Active partners"
//           icon="🚌"
//         />
//         <StatsCard
//           title="BUS DRIVERS"
//           value={dashboardData.totalDrivers}
//           subtitle="Active drivers"
//           icon="👨‍✈️"
//         />
//       </div>

//       <div className="charts-container">
//         <div className="chart-row">
//           <div className="chart-card">
//             <div className="chart-wrapper">
//               <canvas id="incomeExpenseChart"></canvas>
//             </div>
//           </div>
//           <div className="chart-card">
//             <div className="chart-wrapper">
//               <canvas id="ticketBookingChart"></canvas>
//             </div>
//           </div>
//           <div className="chart-card pie-chart">
//             <div className="chart-wrapper">
//               <canvas id="paymentMethodsChart"></canvas>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="content-container">
//         <div className="charts-section">
//           <div className="chart-card">
//             <div className="chart-header">
//               <h3>Tickets / Week - {selectedPeriod}</h3>
//               <span className="time-period">{selectedPeriod}</span>
//             </div>
//             <div className="chart-content">
//               <div className="bar-chart">
//                 {dashboardData.weeklyTickets.map((tickets, index) => (
//                   <div key={index} className="bar-container">
//                     <div 
//                       className="bar" 
//                       style={{ height: `${(tickets / Math.max(...dashboardData.weeklyTickets)) * 100}%` }}
//                       title={`${tickets} tickets`}
//                     ></div>
//                     <span className="bar-label">{['M', 'T', 'W', 'T', 'F', 'S', 'S'][index]}</span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>

//           <div className="chart-card">
//             <div className="chart-header">
//               <h3>Ticket Trends - {selectedPeriod}</h3>
//               <span className="time-period">{selectedPeriod} trend</span>
//             </div>
//             <div className="chart-content">
//               <div className="line-chart">
//                 {dashboardData.todayTickets.map((tickets, index) => (
//                   <div key={index} className="line-point">
//                     <div 
//                       className="point" 
//                       style={{ bottom: `${(tickets / Math.max(...dashboardData.todayTickets)) * 100}%` }}
//                       title={`${tickets} tickets`}
//                     ></div>
//                     <span className="point-label">{index}</span>
//                   </div>
//                 ))}
//                 <div className="line"></div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="lists-section">
//           <UserListCard
//             title="Bus Owners"
//             data={dashboardData.busOwnersList}
//             allData={dashboardData.allBusOwners}
//             columns={['Name', 'Phone', 'Email', 'Buses']}
//           />
          
//           <UserListCard
//             title="Bus Drivers"
//             data={dashboardData.driversList}
//             allData={dashboardData.allDrivers}
//             columns={['Name', 'Phone', 'Bus', 'Experience', 'License']}
//           />

//           <UserListCard
//             title="Bus Conductors"
//             data={dashboardData.conductorsList}
//             allData={dashboardData.allConductors}
//             columns={['Name', 'Phone', 'Bus']}
//           />

//           <UserListCard
//             title="Recent Users"
//             data={dashboardData.usersList}
//             allData={dashboardData.allUsers}
//             columns={['Name', 'Email', 'Phone']}
//           />
//         </div>
//       </div>

//       <div className="recent-bookings">
//         <div className="recent-header">
//           <h3>Recent Ticket Sales - {selectedPeriod}</h3>
//           <button 
//             className="view-all-btn" 
//             onClick={() => openModal('Recent Ticket Sales', dashboardData.allBookings, ['PNR', 'Passenger', 'Route', 'Amount', 'Date'])}
//           >
//             View All
//           </button>
//         </div>
//         <div className="bookings-table">
//           <table>
//             <thead>
//               <tr>
//                 <th>PNR Number</th>
//                 <th>Passenger</th>
//                 <th>Route</th>
//                 <th>Amount</th>
//                 <th>Date</th>
//                 <th>Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {dashboardData.recentBookings.map(booking => (
//                 <tr key={booking._id || booking.id}>
//                   <td className="pnr">{booking.pnr || 'N/A'}</td>
//                   <td className="user">{booking.user?.name || 'N/A'}</td>
//                   <td className="route">{booking.route ? `${booking.route.from} to ${booking.route.to}` : 'N/A'}</td>
//                   <td className="amount">₹{booking.amount || 0}</td>
//                   <td className="date">{booking.bookedOn ? new Date(booking.bookedOn).toLocaleDateString() : 'N/A'}</td>
//                   <td>
//                     <span className={`status ${(booking.status || 'confirmed').toLowerCase()}`}>
//                       {booking.status || 'Confirmed'}
//                     </span>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//           {dashboardData.recentBookings.length === 0 && (
//             <div className="no-data">
//               <p>No bookings found for {selectedPeriod}</p>
//             </div>
//           )}
//         </div>
//       </div>

//       <Modal />
//     </div>
//   );
// };

// export default Home;
import React, { useState, useEffect, useRef } from 'react';
import { Chart, registerables } from 'chart.js';
import { useSelector } from 'react-redux';
import api from '../../Services/api';
import '../../Styles/Dashboard.css';

Chart.register(...registerables);

// Skeleton Components (keep as is)
const SkeletonStatsCard = () => (
  <div className="stats-card skeleton">
    <div className="stats-content">
      <div className="stats-info">
        <div className="skeleton-title"></div>
        <div className="skeleton-value"></div>
        <div className="skeleton-subtitle"></div>
      </div>
      <div className="stats-icon skeleton-icon"></div>
    </div>
  </div>
);

const SkeletonChartCard = () => (
  <div className="chart-card skeleton">
    <div className="chart-header">
      <div className="skeleton-chart-title"></div>
    </div>
    <div className="chart-wrapper">
      <div className="skeleton-chart"></div>
    </div>
  </div>
);

const SkeletonUserListCard = () => (
  <div className="list-card skeleton">
    <div className="list-header">
      <div className="skeleton-list-title"></div>
      <div className="skeleton-button"></div>
    </div>
    <div className="list-content">
      <div className="skeleton-table">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="skeleton-row">
            {[1, 2, 3, 4].map((j) => (
              <div key={j} className="skeleton-cell"></div>
            ))}
          </div>
        ))}
      </div>
    </div>
    <div className="quick-stats">
      <div className="quick-stat">
        <div className="skeleton-stat"></div>
      </div>
      <div className="quick-stat">
        <div className="skeleton-stat"></div>
      </div>
    </div>
  </div>
);

const SkeletonRecentBookings = () => (
  <div className="recent-bookings skeleton">
    <div className="recent-header">
      <div className="skeleton-recent-title"></div>
      <div className="skeleton-button"></div>
    </div>
    <div className="bookings-table">
      <div className="skeleton-table">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="skeleton-row">
            {[1, 2, 3, 4, 5, 6].map((j) => (
              <div key={j} className="skeleton-cell"></div>
            ))}
          </div>
        ))}
      </div>
    </div>
  </div>
);

const Home = () => {
  const { token } = useSelector((state) => state.user);
  
  const [dashboardData, setDashboardData] = useState({
    revenue: 0,
    totalTickets: 0,
    bookedTickets: 0,
    returnedTickets: 0,
    totalUsers: 0,
    totalBusOwners: 0,
    totalDrivers: 0,
    recentBookings: [],
    usersList: [],
    busOwnersList: [],
    driversList: [],
    conductorsList: [],
    allBookings: [],
    allBusOwners: [],
    allDrivers: [],
    allConductors: [],
    allUsers: [],
    chartLabels: [],
    bookingData: [],
    cancelData: [],
    paymentMethods: {},
    topRoutes: []
  });

  const [selectedPeriod, setSelectedPeriod] = useState('all');
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState({
    isOpen: false,
    type: '',
    title: '',
    data: [],
    columns: []
  });

  const bookingChartRef = useRef(null);
  const paymentMethodsChartRef = useRef(null);
  const revenueChartRef = useRef(null);

  useEffect(() => {
    fetchAllData();
  }, [selectedPeriod]);

  useEffect(() => {
    if (!loading && dashboardData.bookingData) {
      createCharts();
    }

    return () => {
      if (bookingChartRef.current) bookingChartRef.current.destroy();
      if (paymentMethodsChartRef.current) paymentMethodsChartRef.current.destroy();
      if (revenueChartRef.current) revenueChartRef.current.destroy();
    };
  }, [dashboardData, loading]);

  // Get date range based on selected period
  const getDateRange = (period) => {
    const now = new Date();
    const dateRange = { dateFrom: null, dateTo: null };
    
    switch (period) {
      case 'Today':
        const today = new Date(now);
        today.setHours(0, 0, 0, 0);
        dateRange.dateFrom = today.toISOString();
        const todayEnd = new Date(now);
        todayEnd.setHours(23, 59, 59, 999);
        dateRange.dateTo = todayEnd.toISOString();
        break;
        
      case 'This Week':
        const startOfWeek = new Date(now);
        const dayOfWeek = now.getDay();
        startOfWeek.setDate(now.getDate() - dayOfWeek);
        startOfWeek.setHours(0, 0, 0, 0);
        dateRange.dateFrom = startOfWeek.toISOString();
        break;
        
      case 'This Month':
        const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        startOfMonth.setHours(0, 0, 0, 0);
        dateRange.dateFrom = startOfMonth.toISOString();
        break;
        
      case 'This Year':
        const startOfYear = new Date(now.getFullYear(), 0, 1);
        startOfYear.setHours(0, 0, 0, 0);
        dateRange.dateFrom = startOfYear.toISOString();
        break;
        
      case 'all':
      default:
        dateRange.dateFrom = null;
        dateRange.dateTo = null;
        break;
    }
    
    return dateRange;
  };

  const fetchAllData = async () => {
    try {
      setLoading(true);
      
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      // Get date range for filtering
      const dateRange = getDateRange(selectedPeriod);

      // Fetch dashboard stats with period filter
      const dashboardResponse = await api.get('/dashboard', {
        ...config,
        params: { period: selectedPeriod }
      });

      // Fetch filtered bookings based on period
      const bookingsParams = {};
      if (dateRange.dateFrom) {
        bookingsParams.dateFrom = dateRange.dateFrom;
      }
      if (dateRange.dateTo) {
        bookingsParams.dateTo = dateRange.dateTo;
      }
      
      // Add pagination params
      bookingsParams.page = 1;
      bookingsParams.limit = 100; // Get enough records for dashboard
      
      const bookingsResponse = await api.get('/bookings', {
        ...config,
        params: bookingsParams
      });

      // Fetch other lists (unfiltered)
      const [
        usersResponse,
        busOwnersResponse,
        driversResponse,
        conductorsResponse
      ] = await Promise.all([
        api.get('/users', config),
        api.get('/bus-owners', config),
        api.get('/drivers', config),
        api.get('/conductors', config)
      ]);

      const dashboardResult = dashboardResponse.data;
      const stats = dashboardResult.stats || {};
      const chartDataFromBackend = dashboardResult.chartData || {};
      
      const users = usersResponse.data.users || [];
      const busOwners = busOwnersResponse.data.busOwners || [];
      const drivers = driversResponse.data.drivers || [];
      const conductors = conductorsResponse.data.conductors || [];
      const bookings = bookingsResponse.data.bookings || [];

      // Bookings are already filtered by API based on date range
      const filteredBookings = bookings;
      
      // Process chart data
      const { bookingData, cancelData } = processChartData(
        chartDataFromBackend.bookingTrends || [],
        chartDataFromBackend.labels || [],
        selectedPeriod
      );

      // Process payment methods
      const paymentMethods = processPaymentMethods(chartDataFromBackend.paymentMethods || []);

      setDashboardData({
        revenue: stats.totalRevenue || stats.paymentCollectionRevenue || 0,
        totalTickets: stats.totalBookings || stats.ticketOrdered || 0,
        bookedTickets: stats.bookedTickets || 0,
        returnedTickets: stats.refundedTickets || 0,
        totalUsers: stats.totalUsers || users.length,
        totalBusOwners: stats.totalOwners || busOwners.length,
        totalDrivers: drivers.length,
        recentBookings: filteredBookings.slice(0, 10),
        usersList: users.slice(0, 5),
        busOwnersList: busOwners.slice(0, 5),
        driversList: drivers.slice(0, 5),
        conductorsList: conductors.slice(0, 5),
        allBookings: filteredBookings,
        allUsers: users,
        allBusOwners: busOwners,
        allDrivers: drivers,
        allConductors: conductors,
        chartLabels: chartDataFromBackend.labels || [],
        bookingData: bookingData,
        cancelData: cancelData,
        paymentMethods: paymentMethods,
        topRoutes: chartDataFromBackend.topRoutes || []
      });

      setLoading(false);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      setLoading(false);
    }
  };

  const processChartData = (bookingTrends, labels, period) => {
    let bookingData = new Array(labels.length).fill(0);
    let cancelData = new Array(labels.length).fill(0);
    
    bookingTrends.forEach(item => {
      let index = 0;
      
      if (period === 'Today') {
        index = item._id?.hour || 0;
      } else if (period === 'This Week') {
        index = (item._id?.dayOfWeek || 1) - 1;
      } else if (period === 'This Month') {
        index = (item._id?.day || 1) - 1;
      } else if (period === 'This Year') {
        index = (item._id?.month || 1) - 1;
      } else {
        index = (item._id?.month || 1) - 1;
      }
      
      if (index >= 0 && index < labels.length) {
        bookingData[index] = item.confirmedBookings || item.totalBookings || 0;
        cancelData[index] = item.cancelledBookings || 0;
      }
    });
    
    return { bookingData, cancelData };
  };

  const processPaymentMethods = (paymentMethods) => {
    const methods = {
      cash: 0,
      card: 0,
      upi: 0,
      other: 0
    };
    
    paymentMethods.forEach(method => {
      const methodName = (method._id || '').toLowerCase();
      const count = method.count || 0;
      
      if (methodName.includes('cash')) {
        methods.cash = count;
      } else if (methodName.includes('card')) {
        methods.card = count;
      } else if (methodName.includes('upi')) {
        methods.upi = count;
      } else {
        methods.other += count;
      }
    });
    
    return methods;
  };

  const createCharts = () => {
    // Booking Trends Chart
    const bookingCtx = document.getElementById('bookingChart');
    if (bookingCtx) {
      if (bookingChartRef.current) bookingChartRef.current.destroy();
      
      bookingChartRef.current = new Chart(bookingCtx, {
        type: 'bar',
        data: {
          labels: dashboardData.chartLabels,
          datasets: [
            {
              label: 'Confirmed Bookings',
              data: dashboardData.bookingData,
              backgroundColor: '#4CAF50',
              borderColor: '#388E3C',
              borderWidth: 1,
              borderRadius: 4,
            },
            {
              label: 'Cancelled Bookings',
              data: dashboardData.cancelData,
              backgroundColor: '#F44336',
              borderColor: '#D32F2F',
              borderWidth: 1,
              borderRadius: 4,
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'top',
              labels: { usePointStyle: true, padding: 15, font: { size: 11 } }
            },
            title: {
              display: true,
              text: `Ticket Bookings & Cancellations - ${getPeriodLabel()}`,
              font: { size: 14, weight: 'bold' },
              padding: 10
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  return `${context.dataset.label}: ${context.parsed.y}`;
                }
              }
            }
          },
          scales: {
            x: { 
              grid: { display: false }, 
              ticks: { 
                font: { size: 10 },
                maxRotation: 45,
                minRotation: 45
              } 
            },
            y: {
              beginAtZero: true,
              ticks: {
                font: { size: 10 },
                callback: function(value) {
                  return value >= 1000 ? (value/1000).toFixed(1) + 'k' : value;
                }
              },
              grid: { color: '#f0f0f0' }
            }
          }
        }
      });
    }

    // Payment Methods Chart
    const paymentCtx = document.getElementById('paymentMethodsChart');
    if (paymentCtx) {
      if (paymentMethodsChartRef.current) paymentMethodsChartRef.current.destroy();
      
      const paymentData = dashboardData.paymentMethods;
      const labels = Object.keys(paymentData).map(key => key.toUpperCase());
      const data = Object.values(paymentData);
      const total = data.reduce((a, b) => a + b, 0);
      
      paymentMethodsChartRef.current = new Chart(paymentCtx, {
        type: 'pie',
        data: {
          labels: labels,
          datasets: [{
            data: data,
            backgroundColor: ['#4CAF50', '#2196F3', '#FF9800', '#9C27B0'],
            borderColor: '#fff',
            borderWidth: 2,
            hoverOffset: 8
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom',
              labels: { usePointStyle: true, padding: 15, font: { size: 11 } }
            },
            title: {
              display: true,
              text: `Payment Methods - ${getPeriodLabel()}`,
              font: { size: 14, weight: 'bold' },
              padding: 10
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const percentage = ((context.raw / total) * 100).toFixed(1);
                  return `${context.label}: ${context.raw} (${percentage}%)`;
                }
              }
            }
          }
        }
      });
    }
  };

  const getPeriodLabel = () => {
    switch (selectedPeriod) {
      case 'Today': return 'Today';
      case 'This Week': return 'This Week';
      case 'This Month': return 'This Month';
      case 'This Year': return 'This Year';
      default: return 'All Time';
    }
  };

  // Function to fetch filtered bookings for modal
  const fetchFilteredBookingsForModal = async (page = 1, limit = 50) => {
    try {
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      const dateRange = getDateRange(selectedPeriod);
      const params = { page, limit };
      
      if (dateRange.dateFrom) {
        params.dateFrom = dateRange.dateFrom;
      }
      if (dateRange.dateTo) {
        params.dateTo = dateRange.dateTo;
      }

      const response = await api.get('/bookings', {
        ...config,
        params
      });

      return response.data;
    } catch (error) {
      console.error('Error fetching filtered bookings:', error);
      return { bookings: [], total: 0 };
    }
  };

  const openModal = async (title, data, columns) => {
    if (title === 'Bookings') {
      // Fetch filtered bookings for modal
      setLoading(true);
      const result = await fetchFilteredBookingsForModal(1, 200);
      setModal({
        isOpen: true,
        type: title.toLowerCase().replace(' ', '-'),
        title: `All ${title} - ${getPeriodLabel()}`,
        data: result.bookings,
        columns: [...columns, 'Status'],
        total: result.total
      });
      setLoading(false);
    } else {
      setModal({
        isOpen: true,
        type: title.toLowerCase().replace(' ', '-'),
        title: `All ${title} - ${getPeriodLabel()}`,
        data: data,
        columns: [...columns, 'Status']
      });
    }
  };

  const closeModal = () => {
    setModal({
      isOpen: false,
      type: '',
      title: '',
      data: [],
      columns: []
    });
  };

  const StatsCard = ({ title, value, subtitle, icon, color = "#2f92c4" }) => (
    <div className="stats-card" style={{ borderLeftColor: color }}>
      <div className="stats-content">
        <div className="stats-info">
          <h3>{title}</h3>
          <h2>{typeof value === 'number' ? value.toLocaleString() : value}</h2>
          <p>{subtitle}</p>
        </div>
        <div className="stats-icon">{icon}</div>
      </div>
    </div>
  );

  const UserListCard = ({ title, data, allData, columns }) => (
    <div className="list-card">
      <div className="list-header">
        <h3>{title}</h3>
        <button 
          className="view-all-btn" 
          onClick={() => openModal(title, allData, columns)}
        >
          View All
        </button>
      </div>
      <div className="list-content">
        <table>
          <thead>
            <tr>
              {columns.map((col, index) => (
                <th key={index}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.slice(0, 5).map((item, index) => (
              <tr key={item._id || item.id || index}>
                {columns.map((col, cellIndex) => {
                  let value = '';

                  switch (col) {
                    case 'Name':
                      value = item.name || 'N/A';
                      break;
                    case 'Email':
                      value = item.email || 'N/A';
                      break;
                    case 'Phone':
                      value = item.phone || item.mobileNumber || 'N/A';
                      break;
                    case 'Company':
                      value = item.company || 'N/A';
                      break;
                    case 'Buses':
                      value = item.busCount || item.buses || 0;
                      break;
                    case 'Bus':
                      value = item.assignedBus?.busNumber || item.bus || 'N/A';
                      break;
                    case 'Experience':
                      value = item.experience || 'N/A';
                      break;
                    case 'Joined':
                      value = item.createdAt ? new Date(item.createdAt).toLocaleDateString() : 'N/A';
                      break;
                    case 'License':
                      value = item.licenseNumber || 'N/A';
                      break;
                    default:
                      value = item[col.toLowerCase()] || 'N/A';
                  }
                  
                  return <td key={cellIndex}>{value}</td>;
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="quick-stats">
        <div className="quick-stat">
          <h4>Total</h4>
          <p>{allData.length}</p>
        </div>
        <div className="quick-stat">
          <h4>Active</h4>
          <p>{allData.filter(item => item.isActive !== false).length}</p>
        </div>
      </div>
    </div>
  );

  const Modal = () => {
    if (!modal.isOpen) return null;

    return (
      <div className="modal-overlay" onClick={closeModal}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>{modal.title}</h3>
            <button className="modal-close-btn" onClick={closeModal}>×</button>
          </div>
          <div className="modal-body">
            <div className="modal-table-container">
              <table className="modal-table">
                <thead>
                  <tr>
                    {modal.columns.map((col, index) => (
                      <th key={index}>{col}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {modal.data.map((item, index) => (
                    <tr key={item._id || item.id || index}>
                      {modal.columns.map((col, colIndex) => {
                        let value = '';
                        
                        if (col === 'Status') {
                          value = item.isActive === false ? 'Inactive' : item.status || 'Active';
                          return (
                            <td key={colIndex}>
                              <span className={`status-badge ${value.toLowerCase()}`}>
                                {value}
                              </span>
                            </td>
                          );
                        }

                        switch (col) {
                          case 'Name':
                            value = item.name || 'N/A';
                            break;
                          case 'Email':
                            value = item.email || 'N/A';
                            break;
                          case 'Phone':
                            value = item.phone || item.mobileNumber || 'N/A';
                            break;
                          case 'Buses':
                            value = item.busCount || item.buses || 0;
                            break;
                          case 'Bus':
                            value = item.assignedBus?.busNumber || item.bus || 'N/A';
                            break;
                          case 'Experience':
                            value = item.experience || 'N/A';
                            break;
                          case 'Joined':
                            value = item.createdAt ? new Date(item.createdAt).toLocaleDateString() : 'N/A';
                            break;
                          case 'License':
                            value = item.licenseNumber || 'N/A';
                            break;
                          case 'PNR':
                            value = item.pnr || 'N/A';
                            break;
                          case 'Passenger':
                            value = item.user?.name || item.name || 'N/A';
                            break;
                          case 'Route':
                            value = item.route ? `${item.route.from} to ${item.route.to}` : 'N/A';
                            break;
                          case 'Amount':
                            value = `₹${item.amount || item.paymentAmount || 0}`;
                            break;
                          case 'Date':
                            value = item.bookedOn || item.date || (item.createdAt ? new Date(item.createdAt).toLocaleDateString() : 'N/A');
                            break;
                          default:
                            value = item[col.toLowerCase()] || 'N/A';
                        }
                        
                        return <td key={colIndex}>{value}</td>;
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {modal.data.length === 0 && (
              <div className="no-data">
                <p>No data available for {getPeriodLabel()}</p>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <p>Total Records: {modal.total || modal.data.length}</p>
            <button className="modal-close-btn secondary" onClick={closeModal}>
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="dashboard">
        <div className="dashboard-header">
          <div className="skeleton-header"></div>
          <div className="skeleton-filter"></div>
        </div>

        <div className="stats-grid">
          {[1, 2, 3, 4, 5, 6, 7].map((i) => (
            <SkeletonStatsCard key={i} />
          ))}
        </div>

        <div className="charts-container">
          <div className="chart-row">
            <SkeletonChartCard />
            <SkeletonChartCard />
            <SkeletonChartCard />
          </div>
        </div>

        <div className="content-container">
          <div className="charts-section">
            <SkeletonChartCard />
            <SkeletonChartCard />
          </div>

          <div className="lists-section">
            <SkeletonUserListCard />
            <SkeletonUserListCard />
            <SkeletonUserListCard />
            <SkeletonUserListCard />
          </div>
        </div>

        <SkeletonRecentBookings />
      </div>
    );
  }

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>Dashboard - {getPeriodLabel()} View</h1>
        <div className="date-filter">
          <select 
            value={selectedPeriod} 
            onChange={(e) => setSelectedPeriod(e.target.value)}
          >
            <option value="all">All Time</option>
            <option value="Today">Today</option>
            <option value="This Week">This Week</option>
            <option value="This Month">This Month</option>
            <option value="This Year">This Year</option>
          </select>
        </div>
      </div>

      <div className="stats-grid">
        <StatsCard
          title="TOTAL REVENUE"
          value={`₹${dashboardData.revenue.toLocaleString()}`}
          subtitle={`${getPeriodLabel()} revenue`}
          icon="💰"
          color="#4CAF50"
        />
        <StatsCard
          title="TOTAL BOOKINGS"
          value={dashboardData.totalTickets}
          subtitle={`${getPeriodLabel()} bookings`}
          icon="🎫"
          color="#2196F3"
        />
        <StatsCard
          title="CONFIRMED BOOKINGS"
          value={dashboardData.bookedTickets}
          subtitle={`${getPeriodLabel()} confirmed`}
          icon="✅"
          color="#4CAF50"
        />
        <StatsCard
          title="CANCELLED BOOKINGS"
          value={dashboardData.returnedTickets}
          subtitle={`${getPeriodLabel()} cancelled`}
          icon="↩️"
          color="#F44336"
        />
        <StatsCard
          title="TOTAL USERS"
          value={dashboardData.totalUsers}
          subtitle={`${getPeriodLabel()} users`}
          icon="👥"
          color="#9C27B0"
        />
        <StatsCard
          title="BUS OWNERS"
          value={dashboardData.totalBusOwners}
          subtitle="Active partners"
          icon="🚌"
          color="#FF9800"
        />
        <StatsCard
          title="BUS DRIVERS"
          value={dashboardData.totalDrivers}
          subtitle="Active drivers"
          icon="👨‍✈️"
          color="#795548"
        />
      </div>

      <div className="charts-container">
        <div className="chart-row">
          <div className="chart-card" style={{ flex: 2 }}>
            <div className="chart-header">
              <h3>Booking Trends</h3>
            </div>
            <div className="chart-wrapper" style={{ height: '400px' }}>
              <canvas id="bookingChart"></canvas>
            </div>
          </div>
          <div className="chart-card" style={{ flex: 1 }}>
            <div className="chart-header">
              <h3>Payment Methods</h3>
            </div>
            <div className="chart-wrapper" style={{ height: '400px' }}>
              <canvas id="paymentMethodsChart"></canvas>
            </div>
          </div>
        </div>
      </div>

      <div className="content-container">
        <div className="lists-section">
          <UserListCard
            title="Bus Owners"
            data={dashboardData.busOwnersList}
            allData={dashboardData.allBusOwners}
            columns={['Name', 'Phone', 'Email', 'Buses']}
          />
          
          <UserListCard
            title="Bus Drivers"
            data={dashboardData.driversList}
            allData={dashboardData.allDrivers}
            columns={['Name', 'Phone', 'Bus', 'Experience', 'License']}
          />

          <UserListCard
            title="Bus Conductors"
            data={dashboardData.conductorsList}
            allData={dashboardData.allConductors}
            columns={['Name', 'Phone', 'Bus']}
          />

          <UserListCard
            title="Recent Users"
            data={dashboardData.usersList}
            allData={dashboardData.allUsers}
            columns={['Name', 'Email', 'Phone']}
          />
        </div>
      </div>

      <div className="recent-bookings">
        <div className="recent-header">
          <h3>Recent Bookings - {getPeriodLabel()}</h3>
          <button 
            className="view-all-btn" 
            onClick={() => openModal('Bookings', dashboardData.allBookings, ['PNR', 'Passenger', 'Route', 'Amount', 'Date', 'Status'])}
          >
            View All
          </button>
        </div>
        <div className="bookings-table">
          <table>
            <thead>
              <tr>
                <th>PNR Number</th>
                <th>Passenger</th>
                <th>Route</th>
                <th>Amount</th>
                <th>Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {dashboardData.recentBookings.map((booking) => (
                <tr key={booking.id || booking._id}>
                  <td className="pnr">{booking.pnr || 'N/A'}</td>
                  <td className="user">{booking.user?.name || booking.passengerName || 'N/A'}</td>
                  <td className="route">{booking.route ? `${booking.route.from} to ${booking.route.to}` : 'N/A'}</td>
                  <td className="amount">₹{booking.amount || 0}</td>
                  <td className="date">{booking.bookedOn || booking.date || 'N/A'}</td>
                  <td>
                    <span className={`status ${(booking.status || 'confirmed').toLowerCase()}`}>
                      {booking.status || 'Confirmed'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {dashboardData.recentBookings.length === 0 && (
            <div className="no-data">
              <p>No bookings found for {getPeriodLabel()}</p>
            </div>
          )}
        </div>
      </div>

      <Modal />
    </div>
  );
};

export default Home;